<template>
  <div v-if="current.fecha_asignacion" class="support-ticket" @click="onTicketClick(current)">
    <div class="st-meta">
      <div class="badge badge-success-inverted" v-if="current.estado == 'A'">
        {{ current.estado_str }}
      </div>
      <div class="badge badge-warning-inverted" v-if="current.estado == 'B'">
        {{ current.estado_str }}
      </div>
      <i class="os-icon os-icon-ui-09"></i>
      <div class="status-pill green" v-if="current.estado == 'A'"></div>
      <div class="status-pill red" v-if="current.estado == 'C'"></div>
    </div>
    <div class="st-body">
      <div class="ticket-content">
        <h6 class="ticket-title">
          Tarea #{{ current.numero }}
        </h6>
        <div class="ticket-description">
          De: {{ current.tienda_origen_obj.nombre }}
          <br>
          Hacia: {{ current.tienda_destino_obj.nombre }}
        </div>
      </div>
    </div>
    <div class="st-foot">
      <span class="label">Usuario: &nbsp;</span>
      <UsuarioEnTablaComponent :current="current.usuario" />
      &nbsp;
      <span class="label">Creada:</span>
      <span class="value">
        <timeago locale="es" :title="current.fecha_creacion" :auto-update="60" :datetime="current.fecha_creacion">
        </timeago>
      </span>
    </div>
  </div>
</template>

<script>

import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";

export default {
  components: {
    UsuarioEnTablaComponent,
  },
  props: {
    current: {
      type: Object
    }
  },
  mounted() { },
  methods: {
    truncate(text, length, suffix) {
      if (text === undefined || text === null || text == "") {
        return "";
      }
      return text.substring(0, length) + suffix;
    },
    onTicketClick(current) {
      this.$emit("onTicketClick", current.id);
    },
  }
};
</script>
